import styled from "styled-components";

export const ModalBodyContent = styled.div`  
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  & > .upload-facts-modal-drag-and-drop {
    height: 192px;
    max-height: 193px;
  }
`;

export const ModalTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 8x;
`;
